/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".wrapper[_ngcontent-%COMP%]{background-color:#fff;padding:35px 30px}@media (min-width:1199px){.wrapper[_ngcontent-%COMP%]{margin:0 14px;padding:41px 16px}}@media (max-width:1199px){.wrapper[_ngcontent-%COMP%]{margin:10px 205px;padding:23px 40px}}@media (max-width:991px){.wrapper[_ngcontent-%COMP%]{margin:10px}}@media (max-width:576px){.wrapper[_ngcontent-%COMP%]{padding:34px 25px}}"];
export { styles as styles };
